var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDarkModeIconInverted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM0.895874 12C0.895874 18.1326 5.86736 23.1041 12 23.1041C18.1326 23.1041 23.1041 18.1326 23.1041 12C23.1041 5.86736 18.1326 0.895874 12 0.895874C5.86736 0.895874 0.895874 5.86736 0.895874 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 1.02922C14.6076 1.03697 17.5291 2.20025 19.6801 4.26315C21.831 6.32605 23.0353 9.11959 23.0279 12.0292C23.0205 14.9389 21.8021 17.7262 19.6406 19.7782C17.4792 21.8301 14.5519 22.9785 11.5025 22.9708L11.5304 12L11.5583 1.02922Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.053 23.1237C9.07767 23.1227 6.22462 21.949 4.12144 19.8607C2.01826 17.7724 0.837232 14.9406 0.838167 11.9882C0.839101 9.03585 2.02192 6.20478 4.12642 4.11781C6.23093 2.03084 9.08472 0.858925 12.06 0.859866L12.0565 11.9918L12.053 23.1237Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIconInverted);
export default __webpack_public_path__ + "static/media/darkModeIconInverted.64d2be061640c173239baf2ef6d6695b.svg";
export { ForwardRef as ReactComponent };